'use client'
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import Title from "@/components/Title";
import {hover, primary} from "@/styles/globalStyleVars";
import reactHtmlParser from "react-html-parser";
import Description from "@/components/Description";

const MyComponent = ({title,description,className}) => {

    return (
        <StyledComponent className= {`title-desc pt-100 pb-100 ${className}`}>
            <Container>
                <Row>
                    <Col>
                        {reactHtmlParser(description)}
                    </Col>
                </Row>
            </Container>

        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    background-color: ${hover};
    will-change: transform;
    
    p{
        color: #FFFFFF;
        white-space: unset;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        &:not(:last-child){
            margin-bottom: 30px;
        }
    }

    ul{
        margin-top: 30px;
        margin-bottom: 40px;
        li{
            position: relative;
            padding-left: 20px;
            color: #FFF;
            &:after{
                content: '';
                position: absolute;
                top: 7px;
                left: 0;
                width: 8px;
                height: 8px;
                background-color: ${primary};
                border-radius: 50%;
            }
        }
    }
    
    .mb-30{
        margin-bottom: 30px;
    }
    .mt-30{
        margin-top: 30px;
    }
    
  
`
export default MyComponent;